import {createAction} from '@reduxjs/toolkit';
import {NavigateFunction} from 'react-router';
import {CreateBreweryDTO, GetBreweriesDTO} from 'typescript/dto/BreweriesDto';
import GetBreweryPubsDTO from 'typescript/dto/breweryPubsDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {breweriesNamespace} from './breweriesSlice';

const getBreweriesACS = createAction(`${breweriesNamespace}/getBreweriesACS`, withPayloadType<GetBreweriesDTO>());

const getBreweryPubsACS = createAction(
  `${breweriesNamespace}/getBreweryPubsACS`,
  withPayloadType<{id: string; search: GetBreweryPubsDTO}>(),
);

const createBreweryACS = createAction(
  `${breweriesNamespace}/createBreweryACS`,
  withPayloadType<{dto: CreateBreweryDTO; navigate?: NavigateFunction}>(),
);

export {getBreweriesACS, createBreweryACS, getBreweryPubsACS};
